import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

const SETTING_ATOMS = {
    useOldMenu: atomWithStorage("localUserSettings:useOldMenu", false),
};

export type LocalUserSetting = keyof typeof SETTING_ATOMS;

export function useLocalUserSetting(
    setting: LocalUserSetting
): [boolean, (value: boolean) => void] {
    return useAtom(SETTING_ATOMS[setting]);
}
